import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCommunity } from '@contexts/CommunityContext';
import useSubmissionDetails from './hooks/useSubmissionDetails';
import SubmissionDetailsView from './view';

export default function SubmissionDetails({ submissionId }) {
    const { slug } = useParams();
    const { community } = useCommunity();
    const currentCommunity = community.getBySlug(slug);

    const state = useSubmissionDetails({
        submissionId,
        communityId: currentCommunity?.id,
    });

    return <SubmissionDetailsView {...state} slug={slug} />;
}
